// actions.js

import apiClient from './service/apiClient';

export const fetchHealthInfo = (kitID) => async (dispatch) => {
  dispatch({ type: 'FETCH_HEALTH_INFO_REQUEST' }); // Dispatch loading action
  try {
    const response = await apiClient.get(`/getHealthInByKitId?kit_id=${kitID}`);
    dispatch({ type: 'FETCH_HEALTH_INFO_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_HEALTH_INFO_FAILURE', payload: errorMessage });
  }

};

export const fetchGeneInfo = (HealthTraitId, kit_id) => async (dispatch) => {
  dispatch({ type: 'FETCH_GENE_INFO_REQUEST' }); // Dispatch loading action
  try {
    const response = await apiClient.get(`/getHealthGeneByKitId?health_trait_id=${HealthTraitId}&kit_id=${kit_id}`);
    dispatch({ type: 'FETCH_GENE_INFO_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_GENE_INFO_FAILURE', payload: errorMessage });
  }
};

export const fetchBlastOffRuleResult = () => async (dispatch) => {
  dispatch({ type: 'FETCH_BLASTOFF_RULE_REQUEST' }); // Dispatch loading action
  try {
    const response = await apiClient.get(`/getBlastOffRuleResult`);
    dispatch({ type: 'FETCH_BLASTOFF_RULE_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_BLASTOFF_RULE_FAILURE', payload: errorMessage });
  }
};

export const fetchBlastOffReferenceResult = (HealthTraitId) => async (dispatch) => {
  dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_REQUEST' }); // Dispatch loading action
  try {
    const response = await apiClient.get(`/getHealthReferenceByHealthTrait?health_trait_id=${HealthTraitId}`);
    dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_SUCCESS', payload: response.data });
  } catch (error) {
    let errorMessage;
    if (error.response && error.response.status === 404) {
      errorMessage = 'Health trait not found.';
    } else {
      errorMessage = handleError(error);
    }
    dispatch({ type: 'FETCH_BLASTOFF_REFERENCE_FAILURE', payload: errorMessage });
  }
};

export const fetchBlastOffDietRecommendation = (kit_id) => async (dispatch) => {
  dispatch({ type: 'FETCH_BLASTOFF_DIET_REQUEST' }); // Dispatch loading action
  try {
    const response = await apiClient.get(`/geDietRecommendation?kit_id=${kit_id}`);
    dispatch({ type: 'FETCH_BLASTOFF_DIET_SUCCESS', payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'FETCH_BLASTOFF_DIET_FAILURE', payload: errorMessage });
  }
};

// Auth headers are now handled globally by apiClient interceptor

export const postPetSurvey = (formData) => async (dispatch) => {
  dispatch({ type: 'POST_PET_SURVEY_REQUEST' });
  try {
    const response = await apiClient.post(`/postpetsurvey`, formData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    dispatch({ type: 'POST_PET_SURVEY_SUCCESS', payload: response.data });
    return response.data; // ✅ Return the response here
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'POST_PET_SURVEY_FAILURE', payload: errorMessage });
    throw error; // Optional: rethrow for catch block in component
  }
};


// Changed from GET to POST to avoid sensitive data in query params
export const getPetSurvey = (email_id) => async (dispatch) => {
  dispatch({ type: 'GET_PET_SURVEY_REQUEST' });

  try {
    const response = await apiClient.post(`/getSurveyByEmail`, 
      { email: email_id },
      { headers: { 'Content-Type': 'application/json' } }
    );

    dispatch({ type: 'GET_PET_SURVEY_SUCCESS', payload: response.data });
    return response.data;
} catch (error) {
  if (error.response?.status === 404) {
  }
  const errorMessage = handleError(error);
  dispatch({ type: 'GET_PET_SURVEY_FAILURE', payload: errorMessage });
}
};

// Changed from GET to POST to avoid sensitive data in query params
export const getPetSurveyByKitEmail = (email_id, kit_id) => async (dispatch) => {
  dispatch({ type: 'GET_PET_SURVEY_REQUEST' });

  try {
    const response = await apiClient.post(`/getSurveyByEmailAndKit`, 
      { email: email_id, kitId: kit_id },
      { headers: { 'Content-Type': 'application/json' } }
    );

    dispatch({ type: 'GET_PET_SURVEY_SUCCESS', payload: response.data });
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
    }
    const errorMessage = handleError(error);
    dispatch({ type: 'GET_PET_SURVEY_FAILURE', payload: errorMessage });
  }
};

export const updateSurveyImage = (kitId, imgBase64) => async (dispatch) => {
  dispatch({ type: 'UPDATE_SURVEY_IMAGE_REQUEST' });
  try {
    const response = await apiClient.post(`/updateSurveyImage`, {
      Kit_id: kitId,
      imgBase64: imgBase64,
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    dispatch({ type: 'UPDATE_SURVEY_IMAGE_SUCCESS', payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'UPDATE_SURVEY_IMAGE_FAILURE', payload: errorMessage });
    throw error;
  }
};

export const getDuplicateKitidCheck = (kitId) => async (dispatch) => {
  dispatch({ type: 'DUPLICATE_KITID_CHECK_REQUEST' });
  try {
    const response = await apiClient.get(`/getDuplicateKitidCheck`, {
      params: { kitId: kitId },
    });

    dispatch({ type: 'DUPLICATE_KITID_CHECK_SUCCESS', payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: 'DUPLICATE_KITID_CHECK_FAILURE', payload: errorMessage });
    throw error;
  }
};

// Function to handle different error codes
const handleError = (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        return 'Bad Request (400). Please check your input.';
      case 401:
        return 'Unauthorized (401). Please log in.';
      case 404:
        return 'Resource not found (404).';
      case 500:
        return 'Internal Server Error (500). Please try again later.';
      default:
        return `Error: ${error.response.status} - ${error.response.statusText}`;
    }
  } else if (error.request) {
    return 'No response received from the server.';
  } else {
    return `Error: ${error.message}`;
  }
};



